/* unplugin-vue-components disabled */import script from "./BatchBannedWordCheck.vue?vue&type=script&setup=true&lang=js"
export * from "./BatchBannedWordCheck.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__